export default {
    tags: 'Tags',
    resource: 'Label',
    id: 'ID',
    name: 'Name',
    slug: 'Slug',
    description: 'Description',
    is_highlighted: 'Highlighted',
    delete: 'Delete',
    placeholder: 'Type',
    create: 'New tag type',
    type: 'Type',
    tag_type: 'Type',
    types: 'Types',
};
